import { render, staticRenderFns } from "./AddTags2.vue?vue&type=template&id=35305072"
import script from "./AddTags2.vue?vue&type=script&lang=js"
export * from "./AddTags2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports